export default __webpack_public_path__ + "media/metronic/_theme/media/demos/demo4/header-c3590bfc7cc20f577e9708d797e2891d.jpg";